import { createAction, props } from '@ngrx/store';
import { Announcement } from 'app/models/announcement';

export const announcementsReplaced = createAction('ANNOUNCEMENTS_REPLACED', props<{ announcements: Announcement[] }>()); // page load
export const announcementDismissed = createAction('ANNOUNCEMENT_DISMISSED', props<{ slug: string }>());
export const announcementSet = createAction('ANNOUNCEMENT_SET', props<{ announcement: Announcement }>());
export const announcementRemoved = createAction('ANNOUNCEMENT_REMOVED', props<{ slug: string }>());


